module.exports = __webpack_public_path__ + "static/media/shrines-lady.e8ee6815.jpg";